export default __webpack_public_path__ + "static/media/partner7.ab91ea76.png";